import React, { useState, useEffect } from "react";

import {
  Select,
  Button,
  Input,
  FormLabel,
  FormControl,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  Text,
  Avatar,
  Box,
  Flex,
} from "@chakra-ui/react";

import { BANNER_POSITION, ModalType, ROOT_API } from "constants/common";
const errorDefault = {
  name: "",
  appName: "",
  banner: "",
  bannerMobile: "",
  typeToDisplay: "",
};
const stateDefault = {
  name: "",
  banner: null,
  bannerMobile: null,
};
const PreviewBannerDialog = (props) => {
  const cancelRef = React.useRef();
  const { isOpen, onOpen, onClose, fetchData, banner } = props;
  const [bannerAds, setBannerAds] = useState(stateDefault);
  const [error, setError] = useState(errorDefault);

  useEffect(() => {
    setBannerAds(banner);
  }, [banner]);

  function resetAll() {
    setError(errorDefault);
  }

  function cancelAndClose() {
    onClose(ModalType.Detail);
    resetAll();
    setBannerAds(banner);
  }

  return (
    <>
      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={cancelAndClose}
        isOpen={isOpen}
        isCentered
        size="2xl"
      >
        <AlertDialogOverlay />

        <AlertDialogContent>
          <AlertDialogHeader>Preview banner</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            <FormControl>
              <FormLabel>Banner name: {banner?.name}</FormLabel>
            </FormControl>
            <Flex justifyContent={"space-around"} height={"100%"}>
              <Box mt={3} height={"100%"}>
                <Text>
                  Banner PC
                  {/* <br />* Ratio Dimension For Popup Banner (w/h): 300/250 <br />*
                Ratio Dimension For Footer Banner (w/h): 320/50 */}
                </Text>
                <Box
                  width="150px"
                  height="fit-content"
                  display={"flex"}
                  alignItems="center"
                  justifyContent={"center"}
                  overflow={"hidden"}
                >
                  <Avatar
                    h={
                      banner?.position !== BANNER_POSITION.POPUP
                        ? "fit-content"
                        : "100%"
                    }
                    w={
                      banner?.position !== BANNER_POSITION.POPUP
                        ? "fit-content"
                        : "100%"
                    }
                    // minH={banner.position === BANNER_POSITION.TOP ? 120 : 50}
                    src={ROOT_API + "/" + banner?.bannerUrl}
                    borderRadius={0}
                  />
                </Box>
              </Box>
              <Box mt={3} height={"100%"}>
                <Text>
                  Banner Mobile
                  {/* <br />* Ratio Dimension For Popup Banner (w/h): 300/250 <br />*
                Ratio Dimension For Footer Banner (w/h): 320/50 */}
                </Text>
                <Box
                  width="150px"
                  height="fit-content"
                  display={"flex"}
                  alignItems="center"
                  justifyContent={"center"}
                >
                  <Avatar
                    h={
                      banner?.position !== BANNER_POSITION.POPUP
                        ? "fit-content"
                        : "100%"
                    }
                    w={
                      banner?.position !== BANNER_POSITION.POPUP
                        ? "fit-content"
                        : "100%"
                    }
                    // minH={banner.position === BANNER_POSITION.TOP ? 120 : 50}
                    src={ROOT_API + "/" + banner?.bannerUrl_mobile}
                    borderRadius={0}
                  />
                </Box>
              </Box>
            </Flex>
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={cancelAndClose}>
              Cancel
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default PreviewBannerDialog;
